import module from 'finanzas/module.js'
import template from './template.html'

module.config(($stateProvider) => {
  $stateProvider.state('finances.transferenciaRecursos', {
    url: '/transferenciaRecursos',
    data: {
      title: 'Transferencia de recursos',
    },
    resolve: {
      Auth: (Permisos) => Permisos.modulos({editar: 'kendu.finanzas.transferenciaRecursos'}),
      Catalogos: ($catalogos) => $catalogos.$fetch(),
    },
    template,
    controllerAs: 'ctrl',
  })
})



// WEBPACK FOOTER //
// ./src/finanzas/_/transferenciaRecursos/finanzas-transferenciaRecursos.js